export const Home = '/';
export const Profile = '/profile';
export const PageNotFound = '/page-not-found';
export const Login = '/login';